/**
 * Prefer GET /:id; fall back to list+find when BE get-by-id is not yet wired.
 */
export async function getOrFindFromList<T extends { id: string }>(
  getById: () => Promise<T>,
  listAll: () => Promise<T[]>,
  id: string
): Promise<T | null> {
  try {
    const row = await getById();
    if (row) return row;
  } catch {
    /* fall through — many HRMS GETs are still missing on BE */
  }
  const list = await listAll();
  return list.find((r) => r.id === id) ?? null;
}
